export default {
    startLoading(state, value) {
        state.loading.push(value);
    },
    stopLoading(state, value) {
        const filtered = state.loading.filter((item) => item !== value);
        state.loading = filtered;
    },
};
